import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { ConfigProvider } from "../config/config";

@Injectable()
export class TutorialProvider {

    // each app has its own tutorial with different functionality
    // events app, hannover app
    // TODO Switch
    private _firstrun: boolean = false;
    private _init: boolean = false;
    private _appname: string = "";
    public isLoginAllowed: boolean = true;
    public readonly IMAGE_PERMISSION_MESSAGE_KEY = "image_permission";

    constructor(private config: ConfigProvider, private storage: Storage) {
        this.getName();
    }

    async getName() {
        this._appname = (await this.config.config).appId;
    }

    // isFirstRun(): Promise<boolean> {
    //     console.log('isFirtRun, appId=' + this._appname);

    //     return new Promise((resolve, reject) => {
    //         if (!this._init) {
    //             this.init().then((value) => {
    //                 if (value) {
    //                     this.getValue(resolve);
    //                 } else {
    //                     resolve(this._firstrun);
    //                 }
    //             });
    //         }
    //     });
    // }

    isFirstRun(feature?: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.getData(feature).then(data => {
                if (data) {
                    console.log('data', data)
                    resolve(false);
                }
                else {
                    resolve(true);
                }
            })
        });
    }

    getData(feature: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.storage.get('firstrun' + this._appname + feature).then(data => {
                resolve(data);
            });
        });
    }

    setTutorialDone(feature?: string) {
        this.storage.set('firstrun' + this._appname + feature, "false").then(() => {
            this._firstrun = false;
        });
    }

    async getValue(resolve) {
        await this.storage.get('firstrun' + this._appname).then(data => {
            this._firstrun = data;
            this._init = true;
            resolve(this._firstrun);
        }).catch(err => console.log(err));
    }

    init(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.storage.length().then(number => {
                if (number == 0) {
                    this.storage.set('firstrun' + this._appname, true).then(() => {
                        this._firstrun = true;
                        resolve(false);
                    });
                } else {
                    resolve(true);
                }
            });
        });
    }
}

export interface Tutorials {
    isEnabled: boolean;
    size: number;
    tabIndex:number[]
}


// WEBPACK FOOTER //
// /src/providers/tutorial/tutorial.ts